import React, { useEffect, useState } from 'react';
import { CheckCircle2, Circle, Loader2 } from 'lucide-react';

const PHASE_ORDER = [
  'HYDRATE',
  'PREPARE_WORKSPACE',
  'PROVISIONING',
  'REPO_CLONE',
  'CLAUDE_CODE',
];

const PHASE_LABELS = {
  HYDRATE: 'Resolving credentials',
  PREPARE_WORKSPACE: 'Preparing workspace',
  PROVISIONING: 'Provisioning environment',
  REPO_CLONE: 'Cloning repository',
  CLAUDE_CODE: 'Starting Claude Code',
};

function elapsedLabel(startMs) {
  if (!startMs) return '';
  const s = Math.floor((Date.now() - startMs) / 1000);
  if (s < 2) return '';
  return `${s}s`;
}

export default function BuilderProgressCard({ phases }) {
  const [, tick] = useState(0);

  const phaseMap = {};
  let startTs = null;
  for (const p of phases || []) {
    phaseMap[p.phase] = p;
    if (!startTs && p.ts) startTs = p.ts;
  }

  useEffect(() => {
    const id = setInterval(() => tick((v) => v + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const visiblePhases = PHASE_ORDER.filter(
    (key) => phaseMap[key] || (key !== 'REPO_CLONE'),
  );

  return (
    <div className="overflow-hidden rounded-lg border border-slate-800 bg-[#0d1117] p-4 shadow-md">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold text-slate-200">Preparing workspace</span>
        {startTs ? (
          <span className="text-[10px] text-slate-500 tabular-nums">{elapsedLabel(startTs)}</span>
        ) : null}
      </div>
      <div className="space-y-2">
        {visiblePhases.map((key) => {
          const p = phaseMap[key];
          const status = p?.status;
          const isActive = status === 'started';
          const isDone = status === 'completed';
          const label = p?.label || PHASE_LABELS[key] || key;

          return (
            <div key={key} className="flex items-center gap-2.5">
              {isDone ? (
                <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400 shrink-0" />
              ) : isActive ? (
                <Loader2 className="h-3.5 w-3.5 text-emerald-400 animate-spin shrink-0" />
              ) : (
                <Circle className="h-3.5 w-3.5 text-slate-600 shrink-0" />
              )}
              <span
                className={`text-xs ${
                  isDone
                    ? 'text-slate-400'
                    : isActive
                      ? 'text-emerald-200 font-medium'
                      : 'text-slate-600'
                }`}
              >
                {label}
              </span>
            </div>
          );
        })}
      </div>
      <p className="mt-3 text-[10px] text-slate-600">Usually takes 20-40 seconds on first run</p>
    </div>
  );
}
